export enum OfferCheckoutStatus {
  LOADING = 'LOADING',
  READY = 'READY',
  LINK_INVALID = 'LINK_INVALID',
  ALREADY_ACCEPTED = 'ALREADY_ACCEPTED',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  LOAD_FAILED = 'LOAD_FAILED',
  ACCEPTED = 'ACCEPTED'
}
